/**
 * Plan View options for the refactored (V2) published shift plan header
 * (UTR-REFLEX-1163). Static for now — the available views and the resolved
 * "latest published" version will be sourced from the backend once the
 * getShiftPlanOutput contract is extended (UTR-REFLEX-1172).
 */
export interface PlanViewOption {
  value: string;
  /** Full label shown in the Plan View dropdown. */
  label: string;
  /** Shorter label shown in the "Viewing: ..." badge (no "(Latest Published)" suffix). */
  badgeLabel: string;
}

/** Plan View identity values (stable — drive label/version logic, not display). */
export const RCC_PROPOSED_PLAN_VIEW = 'RCC_PROPOSED_LATEST_PUBLISHED';
export const OPERATOR_OVERRIDE_PLAN_VIEW = 'OPERATOR_OVERRIDE';

export const PLAN_VIEW_OPTIONS: PlanViewOption[] = [
  {
    value: RCC_PROPOSED_PLAN_VIEW,
    label: 'RCC Proposed Plan (Latest Published)',
    badgeLabel: 'RCC Proposed Plan',
  },
  {
    value: OPERATOR_OVERRIDE_PLAN_VIEW,
    label: 'Operator Override Plan',
    badgeLabel: 'Operator Override Plan',
  },
];

export const DEFAULT_PLAN_VIEW = PLAN_VIEW_OPTIONS[0].value;
